import { memo } from 'react';
import { isMobile } from 'react-device-detect';
import { mergeClasses } from '@fluentui/react-components';
import { SpotlightLayoutType } from '../../../utils/enums';
import useHeroMediaLayoutStyles from './HeroMediaLayout.styles';

interface Props {
  mediaContent: React.ReactNode
  content: React.ReactNode
  type?: SpotlightLayoutType
  className?: string
  footer?: React.ReactNode
}

const HeroMediaLayout: React.FC<Props> = ({
  mediaContent,
  content,
  type = SpotlightLayoutType.TEXT_LEFT_MEDIA_RIGHT,
  className,
  footer,
}) => {
  const styles = useHeroMediaLayoutStyles();

  const sideContainerClass = isMobile
    ? mergeClasses('hero-media-side-layout-mobile-container', styles.mobileSideContainer, styles.sideContainer)
    : styles.sideContainer;

  const fullSizeRender = (): JSX.Element => (
    <div className={styles.fullSizeContainer} data-testid="hero-media-layout-full-size-body">
      <div className={styles.mediaBackground}>{mediaContent}</div>
      <div className={styles.overlayContent}>{content}</div>
    </div>
  );

  const sideContainerRender = (): JSX.Element => (
    <div className={sideContainerClass} data-testid="hero-media-layout-side-container">
      <div className={styles.leftSideContent}>{content}</div>
      <div className={styles.rightSideContent}>{mediaContent}</div>
    </div>
  );

  return (
    <div className={mergeClasses('container', styles.container, className)} data-testid="hero-media-layout-container">
      {type === SpotlightLayoutType.FULL_SIZE ? fullSizeRender() : sideContainerRender()}
      {footer && (
        <div data-testid="hero-media-layout-footer" className={styles.footer}>
          {footer}
        </div>
      )}
    </div>
  );
};

export default memo(HeroMediaLayout);
